"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemGroup = require("@/api/systemGroup");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tableData: []
    };
  },
  created: function created() {
    this.getActivityPageList();
  },
  methods: {
    getActivityPageList: function getActivityPageList() {
      var _this = this;
      (0, _systemGroup.getActivityPageList)().then(function (res) {
        _this.tableData = res.map(function (item, index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            url: "/pages/activity/index?id=" + item.id
          });
        });
      });
    },
    handleCreate: function handleCreate() {
      // 跳转或弹窗创建页面逻辑
      this.$router.push({
        path: "activity/create"
      });
    },
    handleEdit: function handleEdit(row) {
      if (row.status === 1) {
        this.$message.warning("请先下架后再编辑");
        return;
      }
      // 跳转或弹窗编辑页面逻辑
      this.$router.push({
        path: "activity/detail",
        query: {
          id: row.id
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("确定要删除该页面吗？", "提示", {
        type: "warning"
      }).then(function () {
        var options = {
          id: row.id
        };
        (0, _systemGroup.deleteActivityPage)(options).then(function () {
          _this2.$message.success("删除成功");
          _this2.getActivityPageList(); // 刷新列表
        }).catch(function (error) {
          _this2.$message.error("删除失败：" + error.message);
        });
      }).catch(function () {});
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u8981".concat(row.status === 1 ? "下架" : "上架", "\u8BE5\u6D3B\u52A8\u9875\u9762\u5417\uFF1F"), "提示", {
        type: "warning"
      }).then(function () {
        var options = {
          id: row.id,
          status: row.status === 1 ? 0 : 1 // 切换状态
        };
        (0, _systemGroup.startActivityPage)(options).then(function () {
          _this3.$message.success("".concat(row.status === 1 ? "下架" : "上架", "\u6210\u529F!"));
          _this3.getActivityPageList(); // 刷新列表
        });
      }).catch(function () {});
    }
  }
};